import { StationData } from '@/lib/types/api/stations-data';

/**
 * Returns the passport learn more URL based on station data
 * defaults to /passport/learn-more/ if no station specific URL is found
 */
export function getPassportLearnMoreUrl(stationData: StationData | null | undefined): string {
  const learn_more_passport_url = stationData?.attributes?.learn_more_passport_url;
  const video_portal_url = stationData?.attributes?.video_portal_url;

  if (learn_more_passport_url) {
    return learn_more_passport_url;
  }

  if (video_portal_url) {
    return `${video_portal_url}/passport/learn-more/`;
  }

  return '/passport/learn-more/';
}
